/**
 * Readable text color (white or ink) to place on top of a business brand color.
 * Picks whichever has the higher WCAG contrast ratio against the brand.
 */
export function getReadableInk(hex: string | null | undefined): string {
  if (!hex || !/^#[0-9a-f]{6}$/i.test(hex)) return '#ffffff';
  const channel = (i: number) => {
    const c = parseInt(hex.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  };
  const luminance = 0.2126 * channel(1) + 0.7152 * channel(3) + 0.0722 * channel(5);
  const contrastWhite = 1.05 / (luminance + 0.05);
  const contrastInk = (luminance + 0.05) / 0.0617; // #1d1c21
  return contrastWhite >= contrastInk ? '#ffffff' : '#1d1c21';
}
